module.exports = __webpack_public_path__ + "img/let-that-shit-go_B09NRD6PLJ.91d50a35.jpg";